type LoginStatusListener = () => void

export default class UserAuthorizationService {
  static storagekey = {
    userName: 'foxrenderfarm_userName',
    userId: 'foxrenderfarm_userId',
  }

  // 登录状态监听器列表
  private static listeners: Set<LoginStatusListener> = new Set()

  // 订阅登录状态变化
  static subscribe(listener: LoginStatusListener) {
    this.listeners.add(listener)
    return () => {
      this.listeners.delete(listener)
    }
  }

  // 通知监听器
  private static notify() {
    this.listeners.forEach((listener) => listener())
  }

  static getUserName() {
    if (typeof window !== 'undefined') {
      const userName = window.sessionStorage.getItem(UserAuthorizationService.storagekey.userName)
      return userName ? JSON.parse(userName) : ''
    }
    return ''
  }
  static setUserName(userName: string) {
    if (typeof window !== 'undefined') {
      window.sessionStorage.setItem(
        UserAuthorizationService.storagekey.userName,
        JSON.stringify(userName),
      )
      this.notify()
    }
  }
  static removeUserName() {
    if (typeof window !== 'undefined') {
      window.sessionStorage.removeItem(UserAuthorizationService.storagekey.userName)
      this.notify()
    }
  }
  static isLogined() {
    return !!UserAuthorizationService.getUserName()
  }
  static getUserId() {
    if (typeof window !== 'undefined') {
      const userId = window.sessionStorage.getItem(UserAuthorizationService.storagekey.userId)
      return userId ? JSON.parse(userId) : ''
    }
    return ''
  }

  static setUserId(userId: number) {
    if (typeof window !== 'undefined') {
      window.sessionStorage.setItem(
        UserAuthorizationService.storagekey.userId,
        JSON.stringify(userId),
      )
      this.notify()
    }
  }
  static removeUserId() {
    if (typeof window !== 'undefined') {
      window.sessionStorage.removeItem(UserAuthorizationService.storagekey.userId)
      this.notify()
    }
  }
}
